<template>
  <div class="issue-detail-page">
    <a-card class="issue-detail" size="small" :bordered="false" :loading="loading">
      <div class="issue-detail__header">
        <a-page-header :title="issueData.title" :sub-title="`缺陷详情 #${issueData.key}`" @back="toIssueList">
          <template slot="extra">
            <div style="display: flex; align-items: center; gap: 8px">
              <llm-suggestion key="4" v-tc="{ name: '改进建议' }" :llm-info="issueData.llm_info" @llm-edit="llmEdit" />
              <a-button v-tc="{ name: '编辑' }" type="primary" @click="onEdit">编辑</a-button>
              <a-dropdown placement="bottomRight">
                <a-menu slot="overlay">
                  <a-menu-item v-if="false" key="1" v-tc="{ name: '删除缺陷' }" @click="onDelete"><a-icon type="delete" /> 删除缺陷 </a-menu-item>
                  <a-menu-item key="2" v-tc="{ name: '复制缺陷' }" @click="onCopy"><a-icon type="copy" /> 复制缺陷 </a-menu-item>
                  <a-menu-item key="3" v-tc="{ name: '移动项目' }" @click="onMoveProject"><a-icon type="export" /> 移动项目 </a-menu-item>
                  <a-menu-item key="4" v-tc="{ name: '复制缺陷ID' }" @click="onTextCopy(issueData.key)"><a-icon type="copy" /> 复制缺陷ID </a-menu-item>
                  <a-menu-item key="5" v-tc="{ name: '复制Commit信息' }" @click="onTextCopy(`#${issueData.key}@${issueData.title}`)"><a-icon type="copy" /> 复制Commit信息 </a-menu-item>
                </a-menu>
                <a-button> 更多 <a-icon type="down" /> </a-button>
              </a-dropdown>
            </div>
          </template>
        </a-page-header>
      </div>
      <div class="issue-detail__content">
        <div class="issue-detail__main">
          <a-tabs v-model="issueTabsActive" size="small" @change="onChange">
            <a-tab-pane key="1" tab="详细信息">
              <div class="issue-content">
                <div class="info-group">
                  <div class="info-group__title">缺陷描述</div>
                  <div class="info-group__content">
                    <vditor-preview v-if="checkHtml(issueData.description) === false" :content="issueData.description" />
                    <am-editor v-else :content="issueData.description" model="view" :drag="false" />
                  </div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="变更历史" force-render>
              <issue-record ref="record" :issue-id="issueData.id" />
            </a-tab-pane>
            <a-tab-pane v-if="issueData.workflows && issueData.workflows.length > 0" key="3" tab="关联流程">
              <workflow :table-data="issueData.workflows" />
            </a-tab-pane>
            <a-tab-pane v-if="issueData.releases && issueData.releases.length > 0" key="4" tab="发布评审">
              <workflow-release :table-data="issueData.releases" />
            </a-tab-pane>
          </a-tabs>
          <comment-panel ref="commentRef" mode="issue" :source-id="issueData.id" />
        </div>
        <div v-if="Object.keys(issueData).length > 0" class="issue-detail__sidebar">
          <a-card size="small" class="issue-info" :bordered="false">
            <div class="info-group">
              <div class="info-group__title">基本信息</div>
              <a-descriptions size="small" :column="1">
                <a-descriptions-item label="当前状态">
                  <issue-status-edit :issue-id="issueId" :can-operate="issueData.can_operate" :next-status="issueData.next_status" :status="issueData.status" @change="getIssueDetail" />
                </a-descriptions-item>
                <a-descriptions-item label="等级">
                  {{ issueData.serious !== null ? issueSerious[issueData.serious].label : '--' }}
                </a-descriptions-item>
                <a-descriptions-item label="类型"> {{ issueData.issue_type !== null ? issueTypes[issueData.issue_type].label : '--' }} </a-descriptions-item>
                <a-descriptions-item label="优先级">
                  <a-tag v-if="issueData.priority" :color="issuePrioritys[issueData.priority].color"> {{ issuePrioritys[issueData.priority].label }} </a-tag>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="出现概率"> {{ issueData.chance !== null ? issueChances[issueData.chance].label : '--' }} </a-descriptions-item>
                <a-descriptions-item label="发现阶段">
                  {{ issueData.stage ? issueStages[issueData.stage].label : '--' }}
                </a-descriptions-item>
                <a-descriptions-item label="缺陷点数">
                  <issue-point-edit :source-id="issueId" :source-value="issueData.point" :project_id="projectId" />
                </a-descriptions-item>
              </a-descriptions>
            </div>
            <div class="info-group">
              <div class="info-group__title">处理信息</div>
              <a-descriptions size="small" :column="1">
                <a-descriptions-item label="处理人"><user-profiles v-if="issueData.handler" :value="[issueData.handler.id]" avatar /></a-descriptions-item>
                <a-descriptions-item label="验证人"> <user-profiles v-if="issueData.verifier" :value="[issueData.verifier.id]" avatar /></a-descriptions-item>
                <a-descriptions-item label="责任人"> <user-profiles v-if="issueData.maintainer" :value="[issueData.maintainer.id]" avatar /></a-descriptions-item>
                <a-descriptions-item label="创建人"><user-profiles v-if="issueData.creator" :value="[issueData.creator.id]" avatar /></a-descriptions-item>
                <a-descriptions-item label="最后修改人"><user-profiles v-if="issueData.modifier" :value="[issueData.modifier.id]" avatar /></a-descriptions-item>
              </a-descriptions>
            </div>
            <div class="info-group">
              <div class="info-group__title">关联信息</div>
              <a-descriptions size="small" :column="1">
                <a-descriptions-item label="关联需求">
                  <a v-if="issueData.requirement" :href="requirementLink(issueData.requirement.id)" class="relation-resource" target="_blank">{{ issueData.requirement.title }}</a>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="关联用例">
                  <a v-if="issueData.test_case" :href="caseLink(issueData.test_case.id)" class="relation-resource" target="_blank">{{ issueData.test_case.name }}</a>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="关联迭代">
                  <a v-if="issueData.version" :href="versionLink(issueData.version.id)" class="relation-resource" target="_blank">{{ issueData.version.title }}</a>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="关联任务">
                  <a v-if="issueData.task && JSON.stringify(issueData.task) !== '{}'" :href="taskLink(issueData.task.id)" class="relation-resource" target="_blank">{{ issueData.task.name }}</a>
                  <span v-else>--</span>
                </a-descriptions-item>
                <a-descriptions-item label="系统/平台"> {{ issueData.system || '--' }} </a-descriptions-item>
                <a-descriptions-item label="系统/平台版本"> {{ issueData.system_version || '--' }} </a-descriptions-item>
              </a-descriptions>
            </div>
            <div class="info-group">
              <div class="info-group__title">时间信息</div>
              <a-descriptions size="small" :column="1">
                <a-descriptions-item label="截止时间"> {{ issueData.deadline ? issueData.deadline : '--' }} </a-descriptions-item>
                <a-descriptions-item label="创建时间"> {{ issueData.created_time }} </a-descriptions-item>
                <a-descriptions-item label="更新时间"> {{ issueData.updated_time }} </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-card>
        </div>
      </div>
    </a-card>
    <a-back-top />
    <issue-edit-modal ref="editModalRef" @ok="onOK" @cancel="onCancel" />
    <issue-project-edit ref="issueProjectEditRef" @ok="onMoveOK" />
  </div>
</template>

<script>
import { checkHtml, onCopy as onTextCopy } from '@/utils/utils';
import { issueDetail, issueDelete } from '@/api/project/issue';
import { issueStatus, issuePrioritys, issueTypes, issueChances, issueSerious, issueStages } from '@/utils/dictionary';

import AmEditor from '@/components/AmEditor/index';
import CommentPanel from '@/components/comment/CommentPanel';
import VditorPreview from '@/components/VditorEditor/preview';
import Workflow from '@/pages/project/story/components/Workflow';
import IssueRecord from '@/pages/project/issue/components/IssueRecord';
import LlmSuggestion from '@/pages/project/issue/components/LlmSuggestion';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import IssuePointEdit from '@/pages/project/issue/components/IssuePointEdit';
import IssueStatusEdit from '@/pages/project/issue/components/IssueStatusEdit';
import WorkflowRelease from '@/pages/project/story/components/WorkflowRelease';
import IssueProjectEdit from '@/pages/project/issue/components/IssueProjectEdit';

export default {
  components: {
    AmEditor,
    Workflow,
    IssueRecord,
    CommentPanel,
    VditorPreview,
    LlmSuggestion,
    IssueEditModal,
    IssuePointEdit,
    IssueStatusEdit,
    WorkflowRelease,
    IssueProjectEdit
  },
  data() {
    return {
      issueTypes,
      issueStatus,
      issueStages,
      issueSerious,
      issueChances,
      issuePrioritys,
      loading: true,
      issueTabsActive: '1',
      projectId: parseInt(this.$route.params.project_id) || null,
      issueId: this.$route.query.issueId || null,
      issueData: {
        id: null,
        title: null,
        chance: null,
        serious: null,
        status: null,
        issue_type: null,
        description: null
      },
      tabItems: [
        { key: '1', label: '详细信息' },
        { key: '2', label: '变更历史' },
        { key: '3', label: '关联流程' },
        { key: '4', label: '发布评审' }
      ]
    };
  },
  computed: {
    versionLink() {
      return id =>
        this.$router.resolve({
          name: 'page:project:version',
          query: { version_id: id }
        }).href;
    },
    requirementLink() {
      return id =>
        this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: id }
        }).href;
    },
    caseLink() {
      return id =>
        this.$router.resolve({
          name: 'page:project:quality:case',
          query: { id_list: id }
        }).href;
    },
    taskLink() {
      return id =>
        this.$router.resolve({
          name: 'page:project:task:detail',
          query: { taskId: id }
        }).href;
    }
  },
  created() {
    if (this.issueId !== null) {
      this.getIssueDetail();
    } else {
      this.$router.push({ name: 'page:project:quality:issue' });
    }
  },
  methods: {
    checkHtml,
    onTextCopy,
    // 获取缺陷详情
    getIssueDetail() {
      issueDetail({ project_id: this.projectId, issue_id: this.issueId })
        .then(res => {
          this.issueData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(activeKey) {
      const item = this.tabItems.find(item => item.key === activeKey);
      this.utils.trackClick({ name: '切换卡片', label: item ? item.label : activeKey });
    },

    // 删除缺陷
    onDelete() {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该缺陷吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          issueDelete({ project_id: self.projectId, id: self.issueData.id }).then(() => {
            self.$message.success('删除成功');
            self.toIssueList();
          });
        }
      });
    },

    toIssueList() {
      this.$router.push({ name: 'page:project:quality:issue' });
    },

    // 采纳LLM建议进行编辑
    llmEdit() {
      this.$nextTick(() => {
        this.$refs.editModalRef.onOpen({ issueId: this.issueData.id, edit_type: 1 });
      });
    },

    // 点击编辑
    onEdit() {
      this.$nextTick(() => {
        this.$refs.editModalRef.onOpen({ issueId: this.issueData.id });
      });
    },

    // 点击复制
    onCopy() {
      this.$nextTick(() => {
        this.$refs.editModalRef.onOpen({ copyIssueId: this.issueData.id });
      });
    },

    /**
     * 点击移动项目
     */
    onMoveProject() {
      this.$nextTick(() => {
        this.$refs.issueProjectEditRef.onOpen({ id: this.issueData.id, value: this.issueData.project.id });
      });
    },

    /**
     * 项目移动成功事件，跳转至缺陷详情页
     * @param {*} project_id
     */
    onMoveOK(project_id) {
      this.$router
        .push({
          name: 'page:project:quality:issue:detail',
          params: { project_id: project_id },
          query: { issueId: this.issueId }
        })
        .then(() => {
          this.$router.go(0);
        });
    },

    /**
     * 成功回调事件
     */
    onOK() {
      this.getIssueDetail();
      // 更新评论组件Key，否则会导致无法监听到键盘事件
      this.onCancel();
    },

    onCancel() {
      // 更新评论组件Key，否则会导致无法监听到键盘事件
      this.$nextTick(() => {
        this.$refs.commentRef.setKey();
      });
    }
  }
};
</script>
<style lang="less" scoped>
:deep(.ant-page-header) {
  padding: 8px 16px;
}

.issue-detail-page {
  background-color: #f0f2f5;
}

.issue-detail {
  border-radius: 8px;
  :deep(.ant-card-body) {
    padding: 0;
  }

  &__header {
    padding: 8px 16px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;

    :deep(.ant-page-header) {
      padding: 0;
    }
  }

  &__content {
    display: flex;
    gap: 16px;
    padding: 0 16px 16px 16px;
  }

  &__main {
    flex: 1;
    min-width: 0;
  }

  &__sidebar {
    width: 320px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.issue-info {
  background-color: #fafafa;
  border-radius: 8px;

  :deep(.ant-card-body) {
    padding: 12px;
  }

  .info-group {
    & + .info-group {
      margin-top: 8px;
    }

    &__title {
      margin-bottom: 8px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: 500;
      position: relative;
      padding-left: 12px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #1890ff;
        border-radius: 2px;
      }
    }
  }

  :deep(.ant-descriptions-item) {
    padding-bottom: 16px;
    display: flex;

    &:last-child {
      padding-bottom: 0;
    }

    .ant-descriptions-item-label {
      color: rgba(0, 0, 0, 0.45);
      font-size: 13px;
      line-height: 28px;
      text-align: right;
      padding-right: 4px;
      width: 96px;
      white-space: nowrap;
    }

    .ant-descriptions-item-content {
      color: rgba(0, 0, 0, 0.85);
      font-size: 13px;
      line-height: 28px;
      flex: 1;
      min-width: 0;
      word-break: break-all;
    }
  }

  :deep(.ant-descriptions-row) {
    display: block;
  }
}

.issue-content {
  background-color: #fafafa;
  padding: 16px;
  border-radius: 8px;

  .info-group {
    &__title {
      margin-bottom: 8px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: 500;
      position: relative;
      padding-left: 12px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #1890ff;
        border-radius: 2px;
      }
    }

    &__content {
      color: rgba(0, 0, 0, 0.85);
      font-size: 13px;
      line-height: 22px;
    }
  }
}

.issue-panel {
  border-radius: 4px;
  border: 0;
  background: #fff;
  overflow: hidden;
}

.collapse-button {
  color: #86909c;
}

.relation-resource {
  display: inline-block;
  max-width: 300px;
  line-height: 1.2em;
}
</style>
